import angular, { Injectable, IPromise } from "angular";
import { RecordDataSource } from "../../grids";
import { ColDef } from "../../grids/columns/colDef";
import { IGridSettings } from "../../grids/settings/gridSettingsService";

export interface GridConfiguration {
  columns?: ColDef[];
  onItemCommand?: Injectable<(...args: any[]) => IPromise<void>>;
  gridDataSource?: RecordDataSource;
  defaultSort?: string;
  nameSingular?: string;
  namePlural?: string;
  showAddButton?: boolean;
  showAddButtonPermission?: string;
  gridSelectionChanged?: Injectable<(...args: any[]) => void>;
  showSelectButtons?: boolean;
  gridSettings?: IGridSettings;
  initialSelectedIds?: number[];
}

export const vsServiceName = "recordGridViewService";

export interface GridConfigurationFactory {
  (...args: any[]): GridConfiguration;
}

export class RecordGridViewService {
  constructor(
    private readonly configs: {
      [name: string]: Injectable<GridConfigurationFactory> | undefined;
    },
    private readonly $injector: angular.auto.IInjectorService
  ) {}

  getGridConfiguration(
    name: string,
    config?: GridConfiguration
  ): GridConfiguration | undefined {
    const configFactory = this.configs[name];
    if (configFactory === undefined) return config;

    const gridConfiguration = this.$injector.invoke(configFactory);

    return {
      ...gridConfiguration,
      ...config,
    };
  }
}
